import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IPayment } from '../../models/payment'
import { logout, refreshSession, selectRelation } from '../actions/constants'

export interface IPaymentsState {
  payments: IPayment[]
  isLoading: boolean
}

const initialState: IPaymentsState = {
  payments: [],
  isLoading: false
}

export const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setPayments: (state, action: PayloadAction<IPayment[]>) => {
      state.payments = action.payload
    },
    setPaymentsIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, () => initialState)
      .addCase(selectRelation, () => initialState)
      .addCase(refreshSession, () => initialState)
  }
})

export const {
  setPayments,
  setPaymentsIsLoading
} = paymentsSlice.actions

export default paymentsSlice.reducer
